.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 3px 40px;
  background: var(--color-ffffff);
}

.resultsDisplayed {
  flex: 1 1 0px;
  font-style: italic;
  color: var(--primary-100);
}

.paginationBlock {
  display: flex;
  justify-content: center;
  list-style: none;
  flex: 1 1 0px;
  font:
    normal normal bold 1.1875rem/1.5625rem Roboto,
    sans-serif;
}

.pageSizeOptions {
  display: flex;
  justify-content: flex-end;
  flex: 1 1 0px;
  font-style: italic;
}

.paginationBlock ol {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: nowrap;
}

.navigate {
  border-radius: 64px;
  border: 2px solid var(--primary-100);
  padding: 6px 12px;
  color: var(--primary-100);
  cursor: pointer;
}

.navigate:hover {
  border-radius: 64px;
  background-color: var(--primary-100);
  padding: 6px 12px;
  color: var(--color-ffffff);
  cursor: pointer;
}

.navigateDisable {
  border-radius: 64px;
  border: 2px solid var(--grey);
  padding: 6px 12px;
}

.center {
  text-align: center;
}

.pointille {
  vertical-align: text-top;
  color: var(--grey);
  letter-spacing: 0.2rem;
}

.linkA {
  text-decoration: none;
  background: none;
  font: inherit;
  cursor: pointer;
  padding: 5px 10px;
  color: var(--primary-100);
}

.paginationBlock ul .linkA.active {
  color: var(--primary-100);
}

.paginationBlock ul .linkA.disabled:not(.active) {
  color: var(--grey);
  cursor: not-allowed;
}

.paginationBlock ul .linkA:hover.disabled:not(.active) {
  background-color: inherit;
}

.paginationLabel {
  display: flex;
  align-items: center;
}

.itemPerPage {
  min-width: 120px;
  max-width: 25%;
  flex: 1 1 25%;
  font-family: Quicksand, sans-serif;
  outline: none !important;
  border: none !important;
}

.itemPerPage :global(.select__single-value) {
  color: var(--primary-100);
}

.itemPerPage :global(.select__single-value),
.itemPerPage :global(.select__option) {
  display: inline-flex;
  align-items: center;
}

.itemPerPage :global(.select__control) {
  color: var(--primary-100);
  padding: 4px;
  border: none !important;
  border-radius: 10px;
  box-shadow: none;
  background-color: transparent;
}

.itemPerPage :global(.select__input) {
  color: var(--primary-100);
  font-weight: inherit;
}

.itemPerPage :global(.select__indicator-separator) {
  background-color: var(--primary-100);
}

.itemPerPage :global(.select__indicator) {
  color: var(--primary-100) !important;
}

.itemPerPage :global(.select__option) {
  color: var(--text);
  font-weight: 400;
  font-family: Quicksand, sans-serif;
  transition: 0.3s;
}

.itemPerPage :global(.select__option--is-focused) {
  color: var(--primary-100);
  background-color: var(--primary-100);
}

.itemPerPage :global(.select__option--is-selected) {
  color: var(--primary-100);
  background-color: var(--primary-100);
}
